import React, { useEffect, useState } from "react";
import styles from './index.module.css';
import { useScatterChartProps } from "@mui/x-charts/internals";
import { AnimatedModal } from "..";

const CoinSlider = (props) => {

    

    return (
        <div className={styles.wrap} role="group" aria-label="slider with ruler" style={{"--min": 0, "--val": 50, "--max": 100}}>
  <input onChange={(val) => { props.setVal(val.target.value); val.target.parentNode.style.setProperty('--val', val.target.value);}} id={styles.r} type="range" list={styles.l} max="100"/>
  <output id={styles.o} for={styles.r}></output>
  <datalist className={styles.l}>
    {Array.from(Array(101)).map((_, index) => (index === 50 || index === 100 || index === 10) ? (<option className={styles.opt} value={index} style={{"--idx": index, color: 'rgba(255, 107, 107, calc(1 - .0625*var(--abs))', background: 'linear-gradient(#ff6b6b 0 0) 100%/0.5em 2px no-repeat'}} label={index}></option>) : index % 4 === 0 ? <option className={styles.opt} value={index} style={{"--idx": index}} label={index}></option> : <option className={styles.opt} value={index} style={{"--idx": index}}></option>)}
  </datalist>
  <div style={{transform: 'rotate(-90deg)', zIndex: -1}} className="absolute bottom-0 left-[200px] w-[500px] h-[300px] mb-[0px] flex flex-col items-center justify-start gap-5">
        <div className="w-full flex items-center justify-start gap-2">
            <input onChange={(e) => {e.nativeEvent.data === null ? props.setVal(props.val.substring(0, props.val.length - 1)) : !isNaN(e.nativeEvent.data) && props.setVal(props.val + e.nativeEvent.data);}} value={props.val * 10} className={`${styles.textfield} border-[0.1rem] border-gray-200 font-bold rounded`}/>
            <p className="text-[22px] font-bold">$</p>
        </div>
        <div className="w-full flex items-center justify-start gap-2">
            <input value={props.val < 10 ? (props.val * 1000) : (props.val < 50 ? (props.val * 1100) : props.val < 100 ? parseInt(props.val) * 1200 : 135000)} className={`${styles.textfield} border-[0.1rem] border-gray-200 font-bold rounded`}/>
            <p className="text-[22px] font-bold">Coins</p>
        </div>
        <p className="absolute left-0 mt-[100px] bg-gray-200 w-[200px] h-[30px] rounded font-bold text-lg">
          {props.val < 10 ? 0 : (props.val < 50 ? (props.val * 100) : props.val < 100 ? parseInt(props.val) * 200 : 35000)} Bonus Coins
        </p>

                                        <button
                                        onClick={() => props.reference.current.click()}
                                        type="button"
                                        className={` ${styles.btn} absolute left-0 mt-[150px] bg-green-300 rounded cursor-pointer inline-flex items-center justify-center px-[40px] py-[20px] text-lg font-semibold leading-5 text-white transition-all duration-200`}
                                    >
                                       
                                        Buy
                                    </button>
  </div>
</div>
    )
}

export default CoinSlider